<template>
  <v-app>
    <v-app-bar>
      
      <v-spacer/>
      <v-btn style="color: yellow; font-size: 28px; margin-top: 0px;"
        v-for="item in specialItem"
        :key="item.id"
        :to="`/${item.path}`"
        @click="navigateToArea(item)"
      >
      {{ item.name }}
    </v-btn>
      <v-spacer/>
      <v-btn-toggle
        v-model="gridLayout"
        mandatory
        color="primary"
      >
        <v-btn value="1">1</v-btn>
        <v-btn value="2">2</v-btn>
        <v-btn value="4">4</v-btn>
        <v-btn value="9">9</v-btn>
        <v-btn value="16">16</v-btn>
      </v-btn-toggle>
      
      <!-- Pagination Controls -->
      <div class="d-flex align-center ml-4">
        <v-btn 
          icon 
          @click="prevPage" 
          :disabled="currentPage === 1"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        
        <span class="mx-2">
          {{ currentPage }} / {{ totalPages }}
        </span>
        
        <v-btn 
          icon 
          @click="nextPage" 
          :disabled="currentPage === totalPages"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        
      </div>
    
    </v-app-bar>
    
    <v-main>
      <v-container fluid >
        <v-row :class="`grid-${gridLayout}`">
          <v-col
            v-for="(video, index) in currentPageVideos"
            :key="`${video.id}-${currentPage}-${index}`"
            :cols="calculateColumnSize()"
          >
            <v-card :height="videoHeights[index] || 'auto'">
              <v-responsive :aspect-ratio="videoAspectRatios[index] || 16/9">
                <v-card-subtitle >{{ video?.name || '讀取資料中...' }}</v-card-subtitle>
               
                
<VideoComponent
  :url="video.url"
  :username="video.account"
  :password="video.password"
  @video-loaded="(data)=>onVideoLoaded(data, index)"
  :maxHeight="maxVideoHeight"
  :ptzUrl="video.ptzUrl"
  :ptzAccount="video.ptzAccount"
  :ptzPassword="video.ptzPassword"
  fitMode="contain"
>
</VideoComponent>             
                
              </v-responsive>
            </v-card>
          </v-col>
          
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, computed, defineComponent, watch, onMounted} from 'vue'
import axios from 'axios';
import { useAuthStore } from '../stores/auth.js';
import VideoComponent from '@/components/VideoComponent2.vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const maxVideoHeight = ref(600);
var realX=3840;
var realY=2160;
var scrollDirection=null ;
const router = useRouter();

const props = defineProps({
  userId: {
    type: String,
    required: true,
  },
  
});


const specialItem = ref([]);//ref(JSON.parse(route.query.specialItem));
//console.log('specialItem',specialItem);

//var apiUrl='https://winmax.tw/api';
const apiUrl = window.config.API_URL;

const videoPlayer = ref([]);
const currentPage = ref(1);
const gridLayout = ref('4');
const videoSources = ref([]);
const refHeight = ref(100);
const videoHeights = ref(Array(16).fill('auto'));
const videoAspectRatios = ref(Array(16).fill(16/9));

async function handleMouseDown(event,index,video){
if (props.ptzUrl==='')
  return;
    console.log('url',video.ptzUrl+','+video.account+','+video.password);
   
    event.preventDefault();
    event.stopPropagation();
    
    //console.log('call handleclick');
    handleClick(event,index,video);
}

function extractRtspUrl(wsUrl) {
    try {
        // Create URL object
        const url = new URL(wsUrl);
        
        // Get the 'url' parameter from query string
        const rtspUrl = url.searchParams.get('url');
        
        if (!rtspUrl) {
            throw new Error('No RTSP URL found in query parameters');
        }
        console.log('rtspUrl',rtspUrl);
        return rtspUrl;
    } catch (error) {
        console.error('Error parsing URL:', error);
        return null;
    }
}

function extractCredentials(rtspUrl) {
    try {
      console.log('extractCredentials',rtspUrl);
      const regex = /rtsp:\/\/([^:]+):([^@]+)@/;
      const matches = rtspUrl.match(regex);
      console.log(matches);
      if (!matches) return { username: '', password: '' };
   
      return {
          username: matches[1] || '',
          password: matches[2] || ''
      };
      
    } catch (error) {
        console.error("Invalid URL format:", error);
        return null;
    }
}

const navigateToArea = (item) =>{
  console.log('item0', item);
  console.log('item',item.id);
  
  //const propertyParts = item.property.split(':');
  //const areaId = propertyParts[1];
  //console.log('areaId',areaId);
  fetchVideoSourcesByArea(item.id);
};

const fetchVideoSourcesByArea = async (id) => {
  console.log('id',id);
  try {
    const authStore = useAuthStore();
    const response = await axios.get(`${apiUrl}/camera/getCameraByAreaId?areaid=${id}`);
    videoSources.value = response.data;
    console.log('videoSources',videoSources.value.length);
    switch(videoSources.value.length){
      case 0:
      case 1:
        gridLayout.value='1';
        break;
      case 2:
        gridLayout.value='2';
        break;
      case 3:
      case 4:
        gridLayout.value='4';
        break;
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        gridLayout.value='9';
      break;
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
        gridLayout.value='16';
        break;
      default:
        gridLayout.value='4';
        break;
    }
    console.log('gridLayout',gridLayout.value);
    resetVideoPlayers();
  } catch (error) {
    console.error('Failed to fetch video sources:', error);
  }
};


const resetVideoPlayers = () => {
  console.log('videosource length',videoSources.value.length);
  if (videoSources.value.length <= 0) return;
  currentPageVideos.value.forEach((video, index) => {
    const videoElement = videoPlayer.value[`videoPlayer-${index}`];
    if (videoElement) {
      try {
        if (video.url) {
          console.log(`Video initialized for video ${index}:`, video.url);
        }
      } catch (error) {
        console.error(`Error initializing video for video ${index}:`, error);
      }
    }
  });
};


async function handleClick(event,index,video) {
      event.preventDefault(); 
      console.log('down',event.target);
      const rect = event.target.getBoundingClientRect(); // Get the image position
      var x = event.clientX - rect.left; // Calculate x position relative to the image
      var y = event.clientY - rect.top;  // Calculate y position relative to the image
      var xx=x;
      var yy=y;
      console.log('ori x:'+x+",y:"+y);
      //x=(x-rect.width/2)/rect.width*360;
      //y=(y-rect.height/2)/rect.height*360;
      //console.log(rect.left+','+rect.top+','+rect.width+','+rect.height);
      console.log('real x:'+realX+",y:"+realY);
      x=x/rect.width*realX;
      y=y/rect.height*realY;
      console.log('cal x:'+x+",y:"+y);
      const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      params: {
        isAccepted: true
      }
    }

    const data = {
      x: xx,
      y: yy,
    }

    console.log(JSON.stringify(data));
    console.log('ptzurl',`${apiUrl}/ptz`);
    const response = await axios.post(`${apiUrl}/ptz`, {x:x,y:y,url:video.ptzUrl, account:video.account,password:video.password});
    video.play();
    console.log(response.data);
    
   
}

async function handleScroll(event,index,video) {
  if (video.ptzUrl==='')
    return;
  //const rtspUrl=extractRtspUrl(url);
  //  const urls=rtspUrl.split('/');
  //  const expectUrl=urls[0]+'//'+urls[1]+urls[2];
  //  const credentials = extractCredentials(expectUrl);
  event.preventDefault();
  console.log('index',index);
    const rect = event.target.getBoundingClientRect(); // Get the image position
      var x = event.clientX - rect.left; // Calculate x position relative to the image
      var y = event.clientY - rect.top;  // Calculate y position relative to the image
      var z = event.deltaY;
      console.log('ori x:'+x+",y:"+y+",deltay:"+event.deltaY);
      
    if (event.deltaY < 0) {
      scrollDirection = 'up'; // Scrolling up
      if (event.deltaY <= 8)
    {
      z=200;
    }
    } else if (event.deltaY > 0) {
      scrollDirection = 'down'; // Scrolling down
      if (event.deltaY >= 8)
    {
      z=50;
    }
    }
    x=x/rect.width*realX;
    y=y/rect.height*realY;
    
    
    const data = {
      x: x,
      y: y,
      z: z
    }

    console.log(scrollDirection); // Log scroll direction to console
    console.log('zoomurl',`${apiUrl}/zoom`);
    const response = await axios.post(`${apiUrl}/zoom`, {x:x,y:y,z:z,url:video.ptzUrl, account:video.account,password:video.password});
    video.play();
}


const computedVideoUrl = computed(() => `${apiUrl}/proxy/video`);

const totalPages = computed(() => {
  const itemsPerPage = parseInt(gridLayout.value);
  if (videoSources.value.length <= 0) return 0;
  return Math.ceil(videoSources.value.length / itemsPerPage);
});

const currentPageVideos = computed(() => {
  console.log('videoSources',videoSources);
  if (videoSources.value.length <= 0) return [];

  const itemsPerPage = parseInt(gridLayout.value);
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  const areaChannels = videoSources.value;
  return areaChannels.slice(start, end);
});

const fetchVideoSources = async () => {
  try {
    const authStore = useAuthStore();
    const response = await axios.get(`${apiUrl}/camera/getCamera?userid=${authStore.user}`);
    //videoSources.value = response.data;
    //resetVideoPlayers();
    response.data.forEach((item)=>
    {
      specialItem.value.push(item);
    });
    console.log('specialItem1',response.data);
    console.log('specialItem2',specialItem.value);
  } catch (error) {
    console.error('Failed to fetch video sources:', error);
  }
};




watch(gridLayout, () => {
  currentPage.value = 1;
  resetVideoPlayers();
});

/*
const areaId = ref(null);
watch(areaId, (newVal) => {
  if (newVal) {
    fetchVideoSources();
    resetVideoPlayers();
  }
}, { immediate: true });
*/
onMounted(async ()  => {
  
  //areaId.value = JSON.parse(route.query.areaId || "1"); // or however you derive it
  await fetchVideoSources();
  console.log('check specitalItem',specialItem.value.length);
  if (specialItem.value.length > 0)
  {
    console.log('specialItem length',specialItem.value.length);
    navigateToArea(specialItem.value[0]);
  }
});

const currentPageVideos2=()=> {
      console.log('video length',this.videoSources.length);
      if (this.videoSources.length <=0)
        return 0;
      const itemsPerPage = parseInt(gridLayout.value)
      const start = (currentPage.value - 1) * itemsPerPage
      const end = start + itemsPerPage;

      const areaChannels = videoSources.value;
    
      const pageVideos = areaChannels.slice(start, end)
    
      console.log('Current Page Videos:', pageVideos)

      return pageVideos;//this.videoSources[this.areaId-1].channels.slice(start, end)
    };
    
    const calculateColumnSize=()=> {
      const layoutMap = {
        '1': 12,
        '2': 12,
        '4': 6,
        '9': 4,
        '16': 3
      }
      return layoutMap[gridLayout.value]
    };
    const prevPage=()=> {
      if (currentPage.value > 1) {
        currentPage.value--
        this.$nextTick(() => {
          resetVideoPlayers()
        })
      }
    };
    const nextPage=()=> {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
        this.$nextTick(() => {
          resetVideoPlayers();
        })
      }
    };

    
    /*
    const getCurrentArea=()=>{
        var theArea=  videoSources.value
        console.log('areaid',theArea);
        return theArea; 
    };
    */
    const videoInfo = ref(null);

    const onVideoLoaded=(videoData,index)=> {
      const { width, height, aspectRatio } = videoData;

      console.log(`Video loaded: ${width}x${height}, Duration: ${aspectRatio}s`);

      videoHeights.value[index]=parseInt(height,10)+80;
      videoAspectRatios.value[index] = aspectRatio;
      //alert(refHeight.value);
      /*
      if (videoData.aspectRatio > 3) {
          maxVideoHeight.value = 400;
      } else {
          maxVideoHeight.value = 600;
      }
      */
      
      //this.$emit('video-ready', videoData);
    };

    

</script>

<style scoped>
.video-item {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: auto;
}

.grid-1 .v-col { height: 80vh; }
.grid-4 .v-col { height: 40vh; }
.grid-9 .v-col { height: 30vh; }
.grid-16 .v-col { height: 22vh; }

.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 ratio */
  position: relative;
  overflow: hidden;
}

.video-element {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; /* or 'cover' */
}
</style>
